// Entry point for most pages. Includes all React components except those that have their own packs.
// When you add a top-level React component to a page that uses this pack, add it to `components`.
import LinkedAuthedUserConfirmationModal from 'components/authentication_modals/LinkAuthedUserConfirmationModal'
import LockedModal from 'components/authentication_modals/LockedModal'
import SignInModal from 'components/authentication_modals/SignInModal'
import SignUpModal from 'components/authentication_modals/SignUpModal'
import UnknownReviewerConfirmationModal from 'components/authentication_modals/UnknownReviewerConfirmationModal'
import Wrapper from 'components/commodity_code_picker/Wrapper'
import Uploader from 'components/image_uploader/Uploader'
import SelectContract from 'components/review_contracts/SelectContract'
import { ReviewThankYou } from 'components/reviews/ReviewThankYou'
import { ReviewThankYouHeading } from 'components/reviews/ReviewThankYouHeading'
import { WriteAnotherReviewCta } from 'components/reviews/WriteAnotherReviewCta'
import ReviewTiles from 'components/review_tiles/ReviewTiles'
import SurveySelector from 'components/surveys/phone_portal/SurveySelector'
import UnauthedSupplierSearch from 'components/search/UnauthedSupplierSearch'
import Search from 'components/supplier_onboarding/search'
import Page from 'components/supplier_search/Page'
import TiledListItems from 'components/supplier_show/TiledListItems'
import SearchSuppliers from 'components/SearchSuppliers'
import SupplierReviewLinkForm from 'components/supplier_onboarding/SupplierReviewLinkForm'
import { InboxBase } from 'components/inbox/InboxBase'
import { ReviewSurveyPage } from 'components/surveys/responses/ReviewSurveyPage'
import { mount } from 'packs/config/react_rails'

/**
 * Table of all the components needed in this pack. To add a component, put the string you pass into
 * `react-rails` on the left hand side, and a `require` statement for the component on the right.
 */
const components = {
  'authentication_modals/LinkAuthedUserConfirmationModal': LinkedAuthedUserConfirmationModal,
  'authentication_modals/LockedModal': LockedModal,
  'authentication_modals/SignInModal': SignInModal,
  'authentication_modals/SignUpModal': SignUpModal,
  'authentication_modals/UnknownReviewerConfirmationModal': UnknownReviewerConfirmationModal,
  'commodity_code_picker/Wrapper': Wrapper,
  'image_uploader/Uploader': Uploader,
  'review_contracts/SelectContract': SelectContract,
  'reviews/ReviewThankYou': ReviewThankYou,
  'reviews/ReviewThankYouHeading': ReviewThankYouHeading,
  'reviews/WriteAnotherReviewCta': WriteAnotherReviewCta,
  'review_tiles/ReviewTiles': ReviewTiles,
  'search/UnauthedSupplierSearch': UnauthedSupplierSearch,
  'supplier_onboarding/search': Search,
  'supplier_onboarding/SupplierReviewLinkForm': SupplierReviewLinkForm,
  'supplier_search/Page': Page,
  'supplier_show/TiledListItems': TiledListItems,
  'inbox/InboxBase': InboxBase,
  'surveys/responses/ReviewSurveyPage': ReviewSurveyPage,
  'surveys/phone_portal/SurveySelector': SurveySelector,
  SearchSuppliers
}

mount(components)
